// extracted by mini-css-extract-plugin
export default {"vacanctRoutes":"vacantRoutes_vacanctRoutes__mQtBs"};